export default __webpack_public_path__ + "static/media/detail_big_15_1.ef52d2f7.jpg";